import 'inventory-listing/components/ListingFilters/Components/ListingFiltersHead/ListingFiltersHead.scss';

import React from 'react';
import PropTypes from 'prop-types';

import { LocaleService } from '@sm360/widget-commons-core-services';

import VehicleCriteriaModel from 'inventory-listing/models/VehicleCriteriaModel.js';
import CategoryGroupFilter from 'inventory-listing/components/ListingFilters/Components/CategoryGroupFilter/CategoryGroupFilter.jsx';

class ListingFiltersHead extends React.Component {
    constructor(props) {
        super(props);

        this.resetFilters = this.resetFilters.bind(this);
    }

    resetFilters() {
        const defaultCriteria = new VehicleCriteriaModel({
            colanderSlug: 'used',
        });

        this.props.resetFilters(defaultCriteria);
    }

    render() {
        return (
            <div className="listing-used-filters-head clearfix">
                <div className="listing-used-filters-head-title">{LocaleService.t('FILTERS.TITLE')}</div>
                {/* TODO: RESET DOESN'T WORK
                    <div
                        className="listing-used-filters-head-reset picto-showroom"
                        onClick={this.resetFilters}
                    >
                        {LocaleService.t('BUTTONS.RESET')}
                    </div>
                    */}
                <div className="listing-used-filters-head-mobile-title">{LocaleService.t('REFINE_YOUR_SEARCH')}</div>
                <CategoryGroupFilter
                    seletectedGroup={this.props.colanderGroupSlug}
                    colanderList={this.props.colanderList}
                    hasNewInventory={this.props.hasNewInventory}
                    hasUsedInventory={this.props.hasUsedInventory}
                />
                <button
                    className="listing-used-filters-head-mobile-close picto-showroom"
                    onClick={this.props.onFilterClose}
                />
            </div>
        );
    }
}

ListingFiltersHead.propTypes = {
    onFilterClose: PropTypes.func.isRequired,
    resetFilters: PropTypes.func.isRequired,
    colanderGroupSlug: PropTypes.string.isRequired,
    colanderList: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            slug: PropTypes.string,
        })
    ).isRequired,
    hasUsedInventory: PropTypes.bool.isRequired,
    hasNewInventory: PropTypes.bool.isRequired,
};

ListingFiltersHead.displayName = 'ListingFiltersHead';

export default ListingFiltersHead;
